import { t } from "../../../languages";
import { motion } from 'framer-motion';
import AnimateElem from "../../Utils/AnimateElem";

const TopTen = ({ lang, top10, title = 'top10ranking', animate = false }) => {
    // console.log('TopTen ranking:', top10);

    if (!top10 || top10.length === 0) return null;

    const pos1 = top10 ? top10[0] : null;
    const pos2 = top10 ? top10[1] : null;
    const pos3 = top10 ? top10[2] : null;
    const top7 = top10.length > 3 ? top10.slice(3) : null;

    return <section className='top-ten-ranking'>
        <div className='ranking-header'>{t(lang, title)} <img src="./static/myspace/trophy.svg" alt="" /></div>
        <div className='top3'>
            <div className='second-p'>
                <ul>
                    <AnimateElem
                        elem={<li className='avatar'><img src={`./static/avatar/${pos2 && pos2.avatar ? pos2.avatar : 0}.jpg`} alt="" /></li>}
                        delay={2} finalscale={1.05} animate={animate}
                    />
                    <li className='name'>{pos2 ? pos2.name : '-'}</li>
                    <li className='points'><img src="./static/myspace/coin.svg" alt="" /> {pos2 ? pos2.points : '-'}</li>
                </ul>
            </div>
            <div className='first-p'>

                <ul>
                    <AnimateElem
                        elem={<li className='avatar'><img src={`./static/avatar/${pos1 && pos1.avatar ? pos1.avatar : 0}.jpg`} alt="" /></li>}
                        delay={4} finalscale={1.1} animate={animate}
                    />
                    <li className='name'>{pos1 ? pos1.name : '-'}</li>
                    <li className='points'><img src="./static/myspace/coin.svg" alt="" /> {pos1 ? pos1.points : '-'}</li>
                </ul>
            </div>
            <div className='third-p'>
                <ul>
                    <AnimateElem
                        elem={<li className='avatar'><img src={`./static/avatar/${pos3 && pos3.avatar ? pos3.avatar : 0}.jpg`} alt="" /></li>}
                        delay={0.3} finalscale={1} animate={animate}
                    />
                    <li className='name'>{pos3 ? pos3.name : '-'}</li>
                    <li className='points'><img src="./static/myspace/coin.svg" alt="" /> {pos3 ? pos3.points : '-'}</li>
                </ul>
            </div>
        </div>

        {top7 ? <div className='top-4-10'>
            <ul>
                {top7.map((aU, idx) => {
                    return <li key={idx}>
                        <span>{idx < 6 ? '0' : ''}{idx + 4}</span>
                        <span><img src={`./static/avatar/${aU.avatar ? aU.avatar : 0}.jpg`} alt="" /> {aU.name}</span>
                        <span className='points'><img src="./static/myspace/coin.svg" alt="" /> {aU.points}</span>
                    </li>
                })}
            </ul>
        </div> : null}
    </section>
};

export default TopTen;